// Set custom CSS variables
const root = document.documentElement;

root.style.setProperty('--main-header-color', window.meta.header_colour);
root.style.setProperty('--main-header-stripe-color', window.meta.header_stripe_colour);

// Allow custom logo height
if(window.meta.logo_max_height) {
    root.style.setProperty('--max-logo-height', window.meta.logo_max_height);
}
